import { Breadcrumbs, CssBaseline, Paper } from '@material-ui/core';
import * as ReportAction from 'app/actions/ReportCommunicationProgramAction';
import TextEvents from 'app/components/TextEvents';
import NavMenu from 'components/NavMenu';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import TableScreen from '../ReportCommunicationProgramScreen/TableScreen/TableScreen';
import FilterScreen from './FilterScreen/FilterScreen';
import { useStyles, styles } from './ReportCommunicationProgramStyles';

function ReportCommunicationProgramScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const {idSubdirection, employeeId} = useSelector(state => state.Auth.employeeById);

    useEffect(() => {
        dispatch(ReportAction.clearGrid());
        dispatch(ReportAction.getFilterReportCommunicationProgram({ idSubdirection: idSubdirection, employeeId: employeeId}));
    }, [])

    
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isRepor={true} header=' Cumplimiento Programa de Comunicación' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={`${classes.content}`}>                
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Reportes
                        </Link>
                        <TextEvents
                            text="Reporte Cumplimiento Programa de Comunicación"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>

                    <Paper className={classes.rootPaper}>
                        <FilterScreen
                            // newTraining={newTraining}
                            // FiltroNombre={FiltroNombre}
                            // setFiltroNombre={setFiltroNombre}
                        />
                        <TableScreen>

                        </TableScreen>

                    </Paper>



                </div>
            </div>
        </div>
    )
}

export default ReportCommunicationProgramScreen
